import { API } from 'types/API';

export interface NurturingJourneySettingsComponentState {
  nurturingJourneySettings: API;
}

export type ContainerState = NurturingJourneySettingsComponentState;

// --- Nurturing Journey API response types ---

export const CADENCE_UNITS = ['days', 'months', 'years'] as const;
export type CadenceUnit = (typeof CADENCE_UNITS)[number];

export const STEP_TYPES = [
  'fixed',
  'value_associated_with_previous',
  'alternate',
] as const;
export type StepType = (typeof STEP_TYPES)[number];

export interface NurturingStepBase {
  step_order: number;
  step_type: StepType;
  generated_template_type?: 'dynamic' | 'static';
  cadence_value: number;
  cadence_unit: CadenceUnit;
}

export interface NurturingStepFixed extends NurturingStepBase {
  step_type: 'fixed';
  template_types?: string[];
}

export interface NurturingStepValueAssociated extends NurturingStepBase {
  step_type: 'value_associated_with_previous';
  dsl_name?: string;
}

export interface NurturingStepAlternate extends NurturingStepBase {
  step_type: 'alternate';
  alternate_options?: string[];
  alternate_based_on_previous?: boolean;
}

export type NurturingStep =
  | NurturingStepFixed
  | NurturingStepValueAssociated
  | NurturingStepAlternate;

export interface NurturingStage {
  steps: NurturingStep[];
  max_repeat: number | null;
}

export type NurturingStagesMap = Record<string, NurturingStage>;

export interface RecordTypeConfig {
  nurturing_stages: NurturingStagesMap;
}

export interface NurturingJourneyConfig {
  record_types: {
    unsold?: RecordTypeConfig;
    sold?: RecordTypeConfig;
  };
}

export interface NurturingSegment {
  segment_id: string;
  segment_name: string;
  override?: boolean;
  nurturing_journey_config: NurturingJourneyConfig;
}

export interface NurturingJourneyResponse {
  dealer_id: string;
  segments: NurturingSegment[];
}

export type StaticByDynamicTemplateMap = Record<string, string[]>;

export interface StaticStepHoverData {
  previousDynamicType: string | null;
  allowedStaticTypes: string[];
  mappedByDynamicType?: Record<string, string[]>;
}

// --- Nurturing Journey Versions ---

export type NurturingJourneyVersionStatus = 'PUBLISHED' | 'CREATED' | 'ARCHIVED';

export interface NurturingJourneyVersion {
  _id: string;
  nurturing_journey_status: NurturingJourneyVersionStatus;
  nurturing_journey_version: number | null;
  published_date: string | null;
  archived_date: string | null;
  created_at: string;
  updated_at: string;
}
